import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { setUnauthorizedHandler } from '@/api/client'
import App from '@/App.vue'
import { router } from '@/router'
import { useAuthStore } from '@/stores/auth'
import '@/styles/main.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

const auth = useAuthStore(pinia)
setUnauthorizedHandler(() => {
  auth.clear()
  if (router.currentRoute.value.meta.requiresAuth) {
    void router.replace({ name: 'studio-login', query: { redirect: router.currentRoute.value.fullPath } })
  }
})

app.use(router)
app.mount('#app')
